<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <v-card class="elevation-8">
          <v-toolbar :dark="$vuetify.theme.dark" color="primary">
            <v-toolbar-title>
              {{ $t('Системные настройки') }}
            </v-toolbar-title>
          </v-toolbar>
          <v-row v-if="!!generalError || isLoading" class="my-0 py-0 mx-1">
            <v-col cols="12">
              <v-progress-linear :active="isLoading" color="loader" indeterminate />
            </v-col>
            <v-col class="mx-1">
              <general-error v-if="!!generalError" />
            </v-col>
          </v-row>

          <v-row class="text-left pa-2 ma-2">
            <v-col cols="10" class="align-self-center">
              <text-view
                  :display="isTestMode
                    ? $t('Включен')
                    : $t('Выключен')"
                  :label="$t('Тестовый режим системы')" />
            </v-col>
            <v-col cols="2">
              <!-- Переключение тестового статуса доступно только для основного администратора  -->
              <v-switch
                  v-if="isMainAdmin"
                  :value="isTestMode"
                  :input-value="isTestMode"
                  :true-value="true"
                  :false-value="false"
                  color="primaryiconbtn"
                  @change="changeTestStatus" />
            </v-col>
            <v-col class="align-self-center" cols="10">
              <text-view
                  :display="localizationEnabled
                    ? $t('Разрешено')
                    : $t('Не разрешено')"
                  :label="$t('Переключение языка интерфейса')" />
            </v-col>
            <v-col class="text-left" cols="2">
              <!-- Переключение статуса локализации доступно только для основного администратора  -->
              <v-switch
                  v-if="isMainAdmin"
                  :value="localizationEnabled"
                  :input-value="localizationEnabled"
                  :true-value="true"
                  :false-value="false"
                  color="primaryiconbtn"
                  @change="changeLocalizationStatus" />
            </v-col>
          </v-row>
          <v-divider />
          <v-row v-if="isMainAdmin" class="text-left pa-2 ma-2">
            <v-col class="align-self-center ml-2" cols="10">
              <route-link-with-tip
                  :text="$t('Тестирование SignalR')"
                  :tip="$t('Переход на форму тестирования')"
                  :to="{ path: `${urlRootPath}/signalRTest` }" />
            </v-col>
            <v-col class="align-self-center ml-2" cols="10">
              <route-link-with-tip
                  :text="$t('Просмотр логов')"
                  :tip="$t('Переход на форму просмотра логов')"
                  :to="{ path: `${urlRootPath}/logs` }" />
            </v-col>
            <v-col class="align-self-center ml-2" cols="10">
              <route-link-with-tip
                  :text="$t('Ручной запуск задач')"
                  :tip="$t('Форма запуска задач вне расписания')"
                  :to="{ path: `${urlRootPath}/tasks` }" />
            </v-col>
          </v-row>
          <v-divider />
          <v-row
              v-if="isMainAdmin"
              class="text-left pa-2 ma-2 ml-4">
            <v-col cols="12" class="v-label v-label--active font-weight-bold textcolor--text">
              {{ $t('Версии сборок:') }}
            </v-col>
            <v-col
                class="text-left"
                cols="10">
              <text-view
                  :display="versions.admin"
                  :label="$t('API Admin')" />
              <text-view
                  :display="versions.business"
                  :label="$t('API Business')" />
              <text-view
                  :display="versions.identity"
                  :label="$t('API Identity')" />
              <text-view
                  :display="relevance"
                  :label="$t('Client')" />
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import TextView from '@/components/reused/ui/TextView.vue'
  import RouteLinkWithTip from '@/components/reused/ui/RouteLinkWithTip.vue'
  import GeneralError from '@/components/reused/common/GeneralError.vue'
  import { mapActions, mapState } from 'vuex'
  import { SYSTEM_SETTINGS, RELEVANCE, LOCALIZATION } from '@/constants/store.js'

  export default {
    components: {
      TextView,
      GeneralError,
      RouteLinkWithTip
    },
    data () {
      return {
        isLoading: false
      }
    },
    computed: {
      ...mapState(SYSTEM_SETTINGS.NAMESPACE, {
        versions: state => (state[SYSTEM_SETTINGS.STATE.VERSIONS] || {})
      }),
      ...mapState(RELEVANCE.NAMESPACE, {
        relevance: state => (state[RELEVANCE.STATE.RELEVANCE] || '')
      })
    },
    created () {
      this.initialize()
    },
    beforeDestroy () {
      this.clearStore()
    },
    methods: {
      ...mapActions(SYSTEM_SETTINGS.NAMESPACE, {
        getTestStatusAction: SYSTEM_SETTINGS.ACTIONS.GET_TEST_STATUS,
        changeTestStatusAction: SYSTEM_SETTINGS.ACTIONS.CHANGE_TEST_STATUS,
        getAssemblyVersionsAction: SYSTEM_SETTINGS.ACTIONS.GET_ASSEMBLY_VERSIONS,
        clearAssemblyVersionsAction: SYSTEM_SETTINGS.ACTIONS.CLEAR_ASSEMBLY_VERSIONS,
        getLocalizationStatusAction: SYSTEM_SETTINGS.ACTIONS.GET_LOCALIZATION_STATUS,
        changeLocalizationStatusAction: SYSTEM_SETTINGS.ACTIONS.CHANGE_LOCALIZATION_STATUS
      }),
      ...mapActions(LOCALIZATION.NAMESPACE, {
        setLocaleAction: LOCALIZATION.ACTIONS.SET_LOCALE
      }),
      clearStore: async function () {
        return Promise.all(
          [
            this.clearAssemblyVersionsAction()
          ])
      },
      initialize: async function () {
        try {
          this.isLoading = true
          await Promise.all(
            [
              this.getTestStatusAction(),
              this.getLocalizationStatusAction(),
              this.getAssemblyVersionsAction()
            ])
          this.isLoading = false
        } catch (error) {
          this.isLoading = false
          this.throwIfNotServerError(error)
        }
      },
      changeTestStatus: async function (newValue) {
        try {
          this.isLoading = true
          await this.changeTestStatusAction(newValue || false)
          this.isLoading = false
        } catch (error) {
          this.isLoading = false
          this.throwIfNotServerError(error)
        }
      },
      changeLocalizationStatus: async function (newValue) {
        try {
          this.isLoading = true
          await this.changeLocalizationStatusAction(newValue)
          this.isLoading = false
          if (!newValue) {
            await this.setLocaleAction('ru')
          }
        } catch (error) {
          this.isLoading = false
          this.throwIfNotServerError(error)
        }
      }
    }
  }
</script>
